import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateTransformationService {
    constructor(private datePipe: DatePipe) { }

    transformDate(date: Date | string | undefined | null, dateFormat: string) {
        return this.datePipe.transform(date, dateFormat);
    }
}